import {handleApiError, itemEmpty} from './common.js'
import moduleEditItem from './module-edit-item.js'
import itemPayload from '../item-payload.js'

export default function buildModuleCreate(properties, uri, parsed) {
  const SET_LOADING = 'SET_LOADING'
  const SET_ERROR = 'SET_ERROR'

  return moduleEditItem({
    state: {
      error: '',
      isLoading: false,
    },
    actions: {
      clear: ({dispatch}) => {
        return dispatch('setItem', itemEmpty(properties))
      },
      save: ({ commit, dispatch, getters }) => {
        if (getters.item['@id']) {
          throw new Error('Create store must be cleared after save before a new item may be saved.')
        }
        commit(SET_ERROR, '')
        commit(SET_LOADING, true)

        return new Promise((resolve, reject) => {
          dispatch('api/post', { uri, options: {
              body: JSON.stringify(itemPayload(properties, getters.item))
            }}, { root: true })
            .then(response => response.json())
            .then((data) => {
              commit(SET_LOADING, false)
              commit(SET_ERROR, '')
              Promise.all([
                dispatch('setViolations', null),
                dispatch('setItem', data)
              ]).then(() => {
                resolve(data)
              }).catch(e => {
                reject(e)
              })
            })
            .catch((error) => {
              commit(SET_LOADING, false)
              handleApiError({commit, dispatch}, error)
              reject(error)
            })
        })
      },
    },
    getters: {
      error: state => state.error,
      isLoading: state => state.isLoading
    },
    mutations: {
      [SET_ERROR] (state, error) {
        Object.assign(state, { error })
      },
      [SET_LOADING] (state, isLoading) {
        Object.assign(state, { isLoading })
      },
    }
  }, {properties, parsed})
}
